<!-- src/components/Reportes/MermasVenaScrap/MermasVenaScrapDashboard.vue -->
<template>
  <div class="mvs-dashboard">
    <MVSSelectorPeriodo
      :periodo-principal="periodoPrincipal"
      :maquinas-seleccionadas="maquinasSeleccionadas"
      :catalogo-maquinas="catalogoMaquinas"
      :cargando-maquinas="cargandoMaquinas"
      @update:periodo-principal="actualizarPeriodoPrincipal"
      @update:maquinas-seleccionadas="actualizarMaquinasSeleccionadas"
    />

    <div class="mvs-dashboard__body">
      <MVSTablaTotales :filas="filasTabla" />

      <div class="mvs-dashboard__grafica">
        <div v-if="cargando" class="mvs-dashboard__loading">Cargando datos...</div>
        <MVSGraficaBarras
          v-else
          :datos="datosMaquinas"
          titulo="Generación de Vena y Scrap Kg"
          :subtitulo="etiquetaPeriodo(periodoPrincipal)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

import MVSSelectorPeriodo from "./components/MVSSelectorPeriodo.vue";
import MVSTablaTotales from "./components/MVSTablaTotales.vue";
import MVSGraficaBarras from "./components/MVSGraficaBarras.vue";
import { useMermasVenaScrap } from "./composables/useMermasVenaScrap";

import "./styles/mermas-vena-scrap.css";

const {
  cargando,
  cargandoMaquinas,
  periodoPrincipal,
  maquinasSeleccionadas,
  catalogoMaquinas,
  datosMaquinas,
  filasTabla,
  etiquetaPeriodo,
  cargarTodo,
  actualizarPeriodoPrincipal,
  actualizarMaquinasSeleccionadas,
} = useMermasVenaScrap();

onMounted(() => {
  cargarTodo();
});
</script>
